import styled from 'astroturf/react';

const CapOverallStatusLabel = styled('strong')`
  padding: 12px 0;
  margin-right: 1em;
`;

const CapOverallStatusWrapper = styled('div')`
  min-width: 250px;

  .chips-filters {
    font-size: 12px;
  }
`;

export default {
  CapOverallStatusLabel,
  CapOverallStatusWrapper
};
